import React from "react";
import "../styles/Pagination.css"; // 必要ならCSS追加

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null; // 1ページしかないなら非表示

  return (
    <div className="pagination">
      <span className="step-links">
        {/* 最初 & 前へ */}
        {currentPage > 1 && (
          <>
            <button onClick={() => onPageChange(1)}>« 最初</button>
            <button onClick={() => onPageChange(currentPage - 1)}>‹ 前</button>
          </>
        )}

        <span className="current">
          {currentPage} / {totalPages}
        </span>

        {/* 次へ & 最後 */}
        {currentPage < totalPages && (
          <>
            <button onClick={() => onPageChange(currentPage + 1)}>次 ›</button>
            <button onClick={() => onPageChange(totalPages)}>最後 »</button>
          </>
        )}
      </span>
    </div>
  );
};

export default Pagination;
